export var CryptoWithdrawalRequestStatusEnum;
(function (CryptoWithdrawalRequestStatusEnum) {
    CryptoWithdrawalRequestStatusEnum["PENDING"] = "PENDING";
    CryptoWithdrawalRequestStatusEnum["REJECTED"] = "REJECTED";
    CryptoWithdrawalRequestStatusEnum["ACCEPTED"] = "ACCEPTED";
})(CryptoWithdrawalRequestStatusEnum || (CryptoWithdrawalRequestStatusEnum = {}));
//# sourceMappingURL=crypto-withdrawal-request-status.enum.js.map